import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  DEFAULT_TICK_POSITION,
  HeatmapModel,
} from "../../../shared/models/heatmap.model";
import { getMotionHeatMapReports } from "../../../store/slices/fault-module/motion-heat-map-report.slice";
import { setBlockOptionsData } from "../../../store/slices/location-block.slice";
import { setSiteOptionsData } from "../../../store/slices/location-site.slice";
import MotionHeatMapReporTableComponent from "./motion-heat-map-report-table.component";
import {
  modifyDataForHeatmapLevel,
  modifyDataForHeatmapSensor,
} from "src/shared/helpers/modify-data-for-heatmap";

const MotionHeatMapReportComponent = () => {
  const [timeVsSensorNodeData, setTimeVsSensorNodeData] =
    useState<HeatmapModel>({
      newData: [],
      identicalStringsList: [],
      locationList: [],
    });
  const [timeVsSensorNodeExtraData, setTimeVsSensorNodeExtraData] =
    useState<any>({
      code: [],
      displayName: [],
      level: [],
    });
  const [sensorTickPositions, setSensorTickPositions] = useState<string[]>([]);
  const [locationTickPositions, setLocationTickPositions] = useState<string[]>(
    []
  );

  const [timeVsLocationData, setTimeVsLocationData] = useState<HeatmapModel>({
    newData: [],
    identicalStringsList: [],
  });

  const dispatch = useDispatch();

  const heatmapData = useSelector((state: any) => {
    return state.motionHeatMapReport.motionHeatMapReports;
  });

  const isLoadingHeatmapData = useSelector((state: any) => {
    return state.motionHeatMapReport.isLoading;
  });

  const checkAllValuesForNull = (arr: any[]) => {
    return arr?.every((value) => value === null) ? null : arr;
  };

  const checkAllListValuesForNull = (data: any[]) => {
    return data?.every((subArray) => subArray?.length === 0) ? [] : data;
  };

  useEffect(() => {
    dispatch(setSiteOptionsData([]));
    dispatch(setBlockOptionsData([]));
  }, []);

  useEffect(() => {
    if (heatmapData?.data?.length) {
      const convertedData = heatmapData?.data?.map((item: any) => [
        item?.sensorDisplayName,
        item?.hour,
        item?.motionCount,
        item?.assetDisplayLocation,
        item?.assetCode,
      ]);

      const locationData = heatmapData?.data?.map((item: any) => [
        item?.location,
        item?.hour,
        item?.motionCount,
      ]);

      const modifiedSensorData = modifyDataForHeatmapSensor(convertedData);
      const {
        identicalStringsList: sensorIdenticalStringsList,
        newData: sensorNewData,
        tickPositions: sensorTickPositions,
        locationList,
      } = modifiedSensorData;

      if (
        !checkAllValuesForNull(sensorIdenticalStringsList) ||
        !checkAllListValuesForNull(sensorNewData)
      ) {
        setTimeVsSensorNodeData({
          identicalStringsList: [],
          newData: [],
          locationList: [],
        });
        setTimeVsSensorNodeExtraData({
          code: [],
          displayName: [],
          level: [],
        });
      } else {
        setTimeVsSensorNodeData({
          identicalStringsList: sensorIdenticalStringsList,
          newData: sensorNewData,
          locationList: locationList,
        });

        const extraData = heatmapData?.data?.map((d: any) => ({
          code: d.assetCode,
          displayName: d.sensorDisplayName,
          level: d.location,
        }));

        setTimeVsSensorNodeExtraData(extraData);
      }

      if (sensorTickPositions && sensorTickPositions?.length) {
        setSensorTickPositions(sensorTickPositions);
      } else {
        setSensorTickPositions(DEFAULT_TICK_POSITION);
      }

      const modifiedLocationData = modifyDataForHeatmapLevel(locationData);

      const {
        identicalStringsList: locationIdenticalStringList,
        newData: locationNewData,
        tickPositions: locationTickPositions,
      } = modifiedLocationData;

      if (
        !checkAllValuesForNull(locationIdenticalStringList) ||
        !checkAllListValuesForNull(locationNewData)
      ) {
        setTimeVsSensorNodeData({
          identicalStringsList: [],
          newData: [],
          locationList: [],
        });
        setTimeVsSensorNodeExtraData({
          code: [],
          displayName: [],
          level: [],
        });
      } else {
        setTimeVsLocationData({
          identicalStringsList: locationIdenticalStringList,
          newData: locationNewData,
        });
      }

      if (locationTickPositions && locationTickPositions?.length) {
        setLocationTickPositions(locationTickPositions);
      } else {
        setLocationTickPositions(DEFAULT_TICK_POSITION);
      }
    } else {
      setTimeVsSensorNodeData({
        newData: [],
        identicalStringsList: [],
        locationList: [],
      });
      setTimeVsSensorNodeExtraData({
        code: [],
        displayName: [],
        level: [],
      });
      setTimeVsLocationData({ newData: [], identicalStringsList: [] });
    }
  }, [heatmapData]);

  const onRefetchData = (
    tcCode = null,
    siteCode = null,
    blockCode = null,
    location = null,
    reportType = null,
    startDate = null,
    // endDate = null,
    floorPlan = null,
    asset = null
  ) => {
    dispatch(
      getMotionHeatMapReports({
        tcCode,
        siteCode,
        blockCode,
        location,
        reportType,
        startDate,
        // endDate,
        floorPlan,
        asset,
      })
    );
  };

  return (
    <div>
      <MotionHeatMapReporTableComponent
        timeVsSensorNodeData={timeVsSensorNodeData}
        timeVsSensorNodeExtraData={timeVsSensorNodeExtraData}
        timeVsLocationData={timeVsLocationData}
        onRefetchData={onRefetchData}
        isLoading={isLoadingHeatmapData}
        locationTickPositions={locationTickPositions}
        sensorTickPositions={sensorTickPositions}
      />
    </div>
  );
};

export default MotionHeatMapReportComponent;
